import React from 'react';

import { HeaderTab } from 'src/components/common/headerTab/HeaderTab';

export type ApiKeyType =
  | 'all'
  | 'organization'
  | 'graph'
  | 'variant'
  | 'subgraph';

interface ApiKeyTypeTabsProps {
  selectedType: ApiKeyType;
  onTypeChange: (type: ApiKeyType) => void;
}

export const ApiKeyTypeTabs = ({
  selectedType,
  onTypeChange,
}: ApiKeyTypeTabsProps) => {
  return (
    <div className="flex">
      <HeaderTab
        tabID="all"
        tabName="All"
        isActive={() => selectedType === 'all'}
        onClick={() => onTypeChange('all')}
      />
      <HeaderTab
        tabID="organization"
        tabName="Organization"
        isActive={() => selectedType === 'organization'}
        onClick={() => onTypeChange('organization')}
      />
      <HeaderTab
        tabID="graph"
        tabName="Graph"
        isActive={() => selectedType === 'graph'}
        onClick={() => onTypeChange('graph')}
      />
      <HeaderTab
        tabID="variant"
        tabName="Variant"
        isActive={() => selectedType === 'variant'}
        onClick={() => onTypeChange('variant')}
      />
      <HeaderTab
        tabID="subgraph"
        tabName="Subgraph"
        isActive={() => selectedType === 'subgraph'}
        onClick={() => onTypeChange('subgraph')}
      />
    </div>
  );
};
